module.exports = ".download-row {\r\n    margin-top: 8px;\r\n}\r\n\r\n.boo-btn-primary, .boo-btn-primary:focus {\r\n    margin: 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-critical-edition-tei-downloads/page-critical-edition-tei-downloads.component.css
// module id = ./src/app/components/pages/page-critical-edition-tei-downloads/page-critical-edition-tei-downloads.component.css
// module chunks = main